import {authHeader} from '../backend'
import {handleResponse} from './handleResponse'

export const settingService = {
  getClubInfoList,
  getClubInfoDetail,
  insertClubInfo,
  updateClubInfo,
  getAlarmReceptInfo,
  setAlarmReceptInfo,
  getAlarmList,
  insertAlarm,
  getClubLogo,
  getAlarm,
  updateAlarm,
  resendAlarm,
  getPushAlarmList,
  getPushAlarmFuncList,
  insertPushAlarm,
  sendPushAbnormalStatus,
  setFcm,
  sendSMS,
  sendSMSGroup
}

function getAlarmReceptInfo () {
  let requestOptions = {
    method: 'GET',
    cache: 'no-cache',
    headers: authHeader()
  }
  return fetch(`${process.env.BASE_API}/setting/alarm-recept?` + Date.now(), requestOptions).then(handleResponse)
}

function setAlarmReceptInfo (alarmReceptInfo) {
  let requestOptions = {
    method: 'PUT',
    cache: 'no-cache',
    headers: authHeader(),
    body: JSON.stringify(alarmReceptInfo)
  }
  return fetch(`${process.env.BASE_API}/setting/alarm-recept?` + Date.now(), requestOptions).then(handleResponse)
}

function getClubInfoList (pageNo, pageSize, activeStatus, manageStatus, aplStatus, searchValue, orderTarget, orderValue) {
  let requestOptions = {
    method: 'GET',
    cache: 'no-cache',
    headers: authHeader()
  }

  let queryString = `?`
  if (pageNo !== undefined && pageNo !== '') {
    queryString += `pageNo=${pageNo}&`
  }
  if (pageSize !== undefined && pageSize !== '') {
    queryString += `pageSize=${pageSize}&`
  }
  if (activeStatus !== undefined && activeStatus !== '') {
    queryString += `activeStatus=${activeStatus}&`
  }
  if (manageStatus !== undefined && manageStatus !== '') {
    queryString += `manageStatus=${manageStatus}&`
  }
  if (aplStatus !== undefined && aplStatus !== '') {
    queryString += `aplStatus=${aplStatus}&`
  }
  if (searchValue !== undefined && searchValue !== '') {
    queryString += `searchValue=${encodeURI(searchValue)}&`
  }
  if (orderTarget !== undefined && orderTarget !== '') {
    queryString += `orderTarget=${orderTarget}&`
  }
  if (orderValue !== undefined && orderValue !== '') {
    queryString += `orderValue=${orderValue}&`
  }
  return fetch(`${process.env.BASE_API}/setting/club-info/list${queryString}` + Date.now(), requestOptions).then(handleResponse)
}

function getClubInfoDetail (ccode) {
  let requestOptions = {
    method: 'GET',
    cache: 'no-cache',
    headers: authHeader()
  }
  return fetch(`${process.env.BASE_API}/setting/club-info/${ccode}?` + Date.now(), requestOptions).then(handleResponse)
}

function insertClubInfo (clubInfo) {
  let requestOptions = {
    method: 'POST',
    cache: 'no-cache',
    headers: authHeader(),
    body: JSON.stringify(clubInfo)
  }
  return fetch(`${process.env.BASE_API}/setting/club-info}?` + Date.now(), requestOptions).then(handleResponse)
}

function updateClubInfo (ccode, clubInfo) {
  let requestOptions = {
    method: 'PUT',
    cache: 'no-cache',
    headers: authHeader(),
    body: JSON.stringify(clubInfo)
  }
  return fetch(`${process.env.BASE_API}/setting/club-info/${ccode}?` + Date.now(), requestOptions).then(handleResponse)
}

function getClubLogo (ccode) {
  let requestOptions = {
    method: 'GET',
    cache: 'no-cache',
    headers: authHeader()
  }
  return fetch(`${process.env.BASE_API}/setting/club-info/logo/${ccode}?` + Date.now(), requestOptions).then(handleResponse)
}

function getAlarmList (pageNo, pageSize, status, alarmMethod, targetList, searchValue) {
  let requestOptions = {
    method: 'GET',
    cache: 'no-cache',
    headers: authHeader()
  }
  let queryString = `?`
  if (pageNo !== undefined && pageNo !== '') {
    queryString += `pageNo=${pageNo}&`
  }
  if (pageSize !== undefined && pageSize !== '') {
    queryString += `pageSize=${pageSize}&`
  }
  if (status !== undefined && status !== '') {
    queryString += `status=${status}&`
  }
  if (alarmMethod !== undefined && alarmMethod !== '') {
    queryString += `alarmMethod=${alarmMethod}&`
  }
  if (targetList !== undefined && targetList !== '') {
    queryString += `targetList=${targetList}&`
  }
  if (searchValue !== undefined && searchValue !== '') {
    queryString += `searchValue=${encodeURI(searchValue)}&`
  }
  return fetch(`${process.env.BASE_API}/setting/alarm/list${queryString}` + Date.now(), requestOptions).then(handleResponse)
}

function insertAlarm (alarmInfo) {
  let requestOptions = {
    method: 'POST',
    cache: 'no-cache',
    headers: authHeader(),
    body: JSON.stringify(alarmInfo)
  }
  return fetch(`${process.env.BASE_API}/setting/alarm/insert`, requestOptions).then(handleResponse)
}

function getAlarm (alarmId) {
  let requestOptions = {
    method: 'GET',
    cache: 'no-cache',
    headers: authHeader()
  }
  return fetch(`${process.env.BASE_API}/setting/alarm/${alarmId}?` + Date.now(), requestOptions).then(handleResponse)
}

function updateAlarm (alarmId, alarmInfo) {
  let requestOptions = {
    method: 'PUT',
    cache: 'no-cache',
    headers: authHeader(),
    body: JSON.stringify(alarmInfo)
  }
  return fetch(`${process.env.BASE_API}/setting/alarm/${alarmId}?` + Date.now(), requestOptions).then(handleResponse)
}

function resendAlarm (alarmId) {
  let requestOptions = {
    method: 'POST',
    cache: 'no-cache',
    headers: authHeader()
  }
  return fetch(`${process.env.BASE_API}/setting/alarm/resend/${alarmId}`, requestOptions).then(handleResponse)
}

function getPushAlarmList () {
  let requestOptions = {
    method: 'GET',
    cache: 'no-cache',
    headers: authHeader()
  }
  return fetch(`${process.env.BASE_API}/setting/alarm/push?` + Date.now(), requestOptions).then(handleResponse)
}

function getPushAlarmFuncList () {
  let requestOptions = {
    method: 'GET',
    cache: 'no-cache',
    headers: authHeader()
  }
  return fetch(`${process.env.BASE_API}/setting/alarm/func-list?` + Date.now(), requestOptions).then(handleResponse)
}

function insertPushAlarm (alarmInfo) {
  let requestOptions = {
    method: 'POST',
    cache: 'no-cache',
    headers: authHeader(),
    body: JSON.stringify(alarmInfo)
  }
  return fetch(`${process.env.BASE_API}/setting/alarm/push/insert?` + Date.now(), requestOptions).then(handleResponse)
}

function sendPushAbnormalStatus (alarmInfo) {
  let requestOptions = {
    method: 'POST',
    cache: 'no-cache',
    headers: authHeader(),
    body: JSON.stringify(alarmInfo)
  }
  return fetch(`${process.env.BASE_API}/setting/alarm/push/abnormal-status?` + Date.now(), requestOptions).then(handleResponse)
}

function setFcm (token) {
  let requestOptions = {
    method: 'POST',
    cache: 'no-cache',
    headers: authHeader(),
    body: JSON.stringify({token})
  }
  return fetch(`${process.env.BASE_API}/setting/alarm/push/fcm?` + Date.now(), requestOptions).then(handleResponse)
}

function sendSMS (smsInfo) {
  let requestOptions = {
    method: 'POST',
    cache: 'no-cache',
    headers: authHeader(),
    body: JSON.stringify(smsInfo)
  }
  return fetch(`${process.env.BASE_API}/setting/alarm/send-sms?` + Date.now(), requestOptions).then(handleResponse)
}

function sendSMSGroup (smsInfo) {
  let requestOptions = {
    method: 'POST',
    cache: 'no-cache',
    headers: authHeader(),
    body: JSON.stringify(smsInfo)
  }
  return fetch(`${process.env.BASE_API}/setting/alarm/send-sms/group?` + Date.now(), requestOptions).then(handleResponse)
}



// WEBPACK FOOTER //
// ./src/router/settingRouter.js